import { productInformationStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import { css } from "styled-components";

productInformationStyles.container = {
    gap: 0,
    css: css`
        width: 100%;
    `,
};
productInformationStyles.partNumbersGridItem = {
    width: 12,
    css: css`
        padding: 0;
    `,
};

productInformationStyles.availabilityGridItem={
    width: 12,
    css: css`
        display:none;
    `,
}
